<script lang="ts">
    import {Address} from "../../models/Address";
    import {USState} from "../../models/USState";
    import {getAllUSStates, getLengthOfResidenceTypes, Suffixes} from "../../services/ApplicationDataService";

    let lengthOfResidentTypes: string[];
    lengthOfResidentTypes = getLengthOfResidenceTypes();
    const zipPattern = "^[0-9]{5}$";
    const zipRegex = new RegExp(zipPattern);
    let usStates = getAllUSStates();
    export let showLengthOfResidence = "false";
    export let address: Address;
    if (!address) {
        address = new Address();
    }
</script>

<div class="control-row">
    <div class="control-group-horizontal">
        <label>Address1:</label>
        <input bind:value={address.address1} required />
          {#if  !address.address1  }
                    <span class="invalidlabel">Address1 is required</span>
                {/if}
    </div>
</div>

<div class="control-row">
    <div class="control-group-horizontal">
        <label>Address2:</label>
        <input bind:value={address.address2} />
    </div>
</div>
<div class="control-row">
    <div class="control-group-horizontal">
        <label>City:</label>
        <input bind:value={address.city} required/>
          {#if  !address.city  }
                            <span class="invalidlabel">City is required</span>
                        {/if}
    </div>
</div>
<div class="control-row">
    <div class="control-group-horizontal">
        <label>State:</label>
        <select bind:value={address.state} required >
            <option value=''> Select State </option>
            {#each usStates as state}
                <option value={state.abbreviation}> {state.name}
                </option>
            {/each}
        </select>
          {#if  !address.state }
                            <span class="invalidlabel">State is required</span>
                        {/if}
    </div>
</div>
<div class="control-row">
    <div class="control-group-horizontal">
        <label>Zip:</label>
        <input bind:value={address.zipCode} maxlength="5" required pattern={zipPattern} type="tel"/>
        {#if !address.zipCode || !zipRegex.test(address.zipCode)}
          <span class="invalidlabel">Valid zip code is required</span>
        {/if}
    </div>
</div>
{#if showLengthOfResidence == "true"}
<div class="control-row">
    <div class="control-group-horizontal">
        <label>Length of Time at Residence:</label>
        <select bind:value={address.lengthOfResidence} >
            <option value=''> Select  </option>
            {#each lengthOfResidentTypes as length}
                <option value={length}> {length}
                </option>
            {/each}
        </select>
    </div>
</div>
    {/if}
<style lang="scss">
  @use "../../../component_scss_library/layout" as layout;
  @use "../../../component_scss_library/forms" as forms;
</style>

